import { useState } from "react";
import { postAuthForm } from "../api/client";
import { Button, ErrorBanner } from "../components/ui";

export function Login() {
  const params = new URLSearchParams(window.location.search);
  const denied = params.has("error");
  const callbackUrl = params.get("callbackUrl") ?? `${window.location.origin}/new/eng`;
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <div className="app">
      <div className="login-wrap">
        <section className="panel" style={{ minHeight: 0 }}>
          <div className="login-logo">
            <img className="logo-on-light" src="/logo-light.svg" alt="Triage Desk" />
            <img className="logo-on-dark" src="/logo-dark.svg" alt="" />
          </div>
          <p className="brand-sub login-sub">Issue intake &amp; AI pre-triage · Vestd Engineering</p>
          <div className="phase-head">
            <h1>Sign in</h1>
            <p>Use your Vestd Google account to raise an engineering ticket or report an incident.</p>
          </div>
          <div className="issue-form">
            {denied && <ErrorBanner>That account can't sign in. Use your vestd.com Google account.</ErrorBanner>}
            {failed && <ErrorBanner>We couldn't start sign-in. Please try again.</ErrorBanner>}
            <div className="form-actions" style={{ justifyContent: "flex-start" }}>
              <Button
                disabled={busy}
                onClick={() => {
                  setBusy(true);
                  postAuthForm("/api/auth/signin/google", callbackUrl).catch(() => {
                    setFailed(true);
                    setBusy(false);
                  });
                }}
              >
                Sign in with Google
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
